export default {
  "pl": {
    "lot": {
      "attributes": {
        "end_date": "Data ukończenia",
        "internal_note": "Notatka do użytku wewnętrznego",
        "land_register": "Rejestr nieruchomości",
        "name": "Nazwa",
        "start_date": "Data rozpoczęcia",
        "surface": "Powierzchnia"
      },
      "labels": {
        "lot": "Brak działek | 1 działka | Liczba działek: {count}"
      },
      "toasts": {
        "create": "Utworzono działkę",
        "delete": "Usunięto działkę",
        "update": "Zaktualizowano działkę"
      },
      "validation": {
        "needName": "Należy podać tytuł",
        "needNumber": "Należy podać liczbę (np. 85)"
      }
    }
  }
}
